import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';

import './index.scss';

const initialState = {
  day: '',
  month: '',
  year: '',
  error: null,
};

export default class DateInput extends React.Component {
  static displayName = 'DateInput';
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.object,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    value: {},
    placeholder: '',
  };

  constructor(props) {
    super(props);
    this._setInitialState();
  }

  _setInitialState() {
    let state = initialState;

    if (this.props.value) {
      let { day, month, year } = this.props.value;

      state = { day, month, year, error: null };
    }

    this.state = state;
  }

  getDate() {
    let { day, month, year } = this.state;

    /* Fill in missing zeros from the month & day fields
     * because otherwise the native input fails to read it
     */
    if (month.length === 1) {
      month = '0' + month;
    }
    if (day.length === 1) {
      day = '0' + day;
    }

    return `${year}-${month}-${day}`;
  }

  parseDate(date) {
    let [year, month, day] = date.split('-');

    return { day, month, year };
  }

  change(e) {
    if (Moment(e.target.value, 'YYYY-MM-DD', true).isValid()) {
      let date = this.parseDate(e.target.value);
      let { day, month, year } = date;

      this.setState({ day, month, year, error: null });
      this.props.onChange(date);
    } else {
      this.setState({ error: 'Invalid date' });
    }
  }

  render() {
    let wrapperClasses = `Input-Wrapper ${
      !!this.state.error ? 'is-invalid' : ''
    }`;

    return (
      <div className={wrapperClasses}>
        <input
          className="Input"
          onChange={this.change.bind(this)}
          type="date"
          ref="input"
          placeholder={this.props.placeholder}
          value={this.getDate()}
          name={this.props.name}
        />
        <div className="Input-Error">{this.state.error}</div>
      </div>
    );
  }
}
